import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowUp_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.46967 8.53033C4.17678 8.23744 4.17678 7.76256 4.46967 7.46967L9.46967 2.46967C9.61032 2.32902 9.80109 2.25 10 2.25C10.1989 2.25 10.3897 2.32902 10.5303 2.46967L15.5303 7.46967C15.8232 7.76256 15.8232 8.23744 15.5303 8.53033C15.2374 8.82322 14.7626 8.82322 14.4697 8.53033L10.75 4.81066L10.75 17C10.75 17.4142 10.4142 17.75 10 17.75C9.58579 17.75 9.25 17.4142 9.25 17L9.25 4.81066L5.53033 8.53033C5.23744 8.82322 4.76256 8.82322 4.46967 8.53033Z"
            />
        </SvgStyled>
    );
};

export default ArrowUp_sm;
